/** Subscribe through the command queue so mounting before the widget boots is safe. */
export const subscribeHelplyUnread = listener => {
  if (typeof window === 'undefined' || typeof window.Helply !== 'function') {
    return () => {}
  }
  let active = true
  const onUnread = unread => {
    if (active) listener(unread === true)
  }
  window.Helply('on', 'unreadChange', onUnread)
  return () => {
    active = false
    // The real command replaces the loading stub, so resolve it again on cleanup.
    if (typeof window.Helply === 'function') {
      window.Helply('off', 'unreadChange', onUnread)
    }
  }
}
